
import { UserRole } from "./types";
import { permissionEngine } from "@/services/auth/permissionEngine";
import { EnhancedUser } from "@/context/auth/rbacTypes";

export const useAuthUtils = () => {
  const hasPermission = (user: { role: string; permissions: string[]; id: number; email?: string; is_superuser?: boolean } | null, permission: string): boolean => {
    if (!user) return false;
    if (user.role === 'admin' || user.is_superuser) return true;
    
    // Convert to EnhancedUser and use permissionEngine
    const enhancedUser: EnhancedUser = {
      id: user.id,
      email: user.email || '',
      username: user.email || '',
      first_name: '',
      last_name: '',
      is_active: true,
      is_superuser: user.is_superuser || false,
      permissions: []
    };
    
    return permissionEngine.hasPermission(enhancedUser, permission);
  };

  const hasRole = (user: { role: string } | null, roles: UserRole | UserRole[]): boolean => {
    if (!user) return false;
    if (Array.isArray(roles)) {
      return roles.includes(user.role as UserRole);
    }
    return user.role === roles;
  };

  return {
    hasPermission,
    hasRole,
  };
};
